import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=6346791e&scoped=true"
import script from "./DefaultModal.vue?vue&type=script&lang=js"
export * from "./DefaultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346791e",
  null
  
)

export default component.exports